import axios from "api/client";
export default {
  details: (id) => axios.get(`/courses/${id}`).then((res) => res.data),

  join: (id) => axios.post("/my-courses", { course_id: Number(id) }),
  mine: () => axios.get("/my-courses"),

  // Lesson progress. Omit `completed` to just record a visit (resume point).
  progress: (courseId) =>
    axios.get("/progress", { params: { course_id: courseId } }).then((res) => res.data),
  track: (lessonId, completed) =>
    axios
      .post("/progress", completed === undefined ? { lesson_id: lessonId } : { lesson_id: lessonId, completed })
      .then((res) => res.data),
};
